import { Log } from '@apparel/core/log';
import { stringify } from '@lib/json';
import { isProduction } from '@lib/utils';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { debounce } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

export const pageModule = (mod: any): Promise<any> => {
    let mod$ = null;
    let err$ = null;

    const pageModuleDone = debounce((resolve) => {
        if (err$) {
            const { stack } = (err$ || { stack: null }) as any;

            if (!isProduction()) {
                return resolve((props) => (
                    <ErrorFrame>
                        <h1>Error Frame</h1>
                        <div className="code err">
                            <pre>{stack}</pre>
                        </div>
                        <div className="code">
                            <pre>{stringify(props, 4)}</pre>
                        </div>
                    </ErrorFrame>
                ));
            } else {
                return resolve(() => (
                    <Typography color={'primary'} variant={'caption'}>
                        Ooops! ... Something went wrong!
                    </Typography>
                ));
            }
        }

        resolve(mod$);
    }, 100);

    return new Promise((resolve: any, reject: any) => {
        mod.then((mod) => {
            if (mod) {
                mod$ = mod.default || mod || null;
            }

            pageModuleDone(resolve);
        }).catch((err) => {
            Log.error('pageModule', err);

            err$ = err;
            reject(err);

            // pageModuleDone(reject);
        });

        // Inject custom error
        // setTimeout(() => {
        //     reject(new Error('Loading chunk 115 failed.'));
        // }, 1000);
    });
};

const ErrorFrame = styled(Container)`
    position: relative;
    top: 40px;
    padding: 14px;

    h1 {
        color: #444;
        font-size: 18px;
        margin: 14px 0 0 0;
    }

    .code {
        display: inline-block;
        overflow: auto;
        max-width: 100%;
        margin: 14px 0;
        background-color: #f5f5f5;
        padding: 14px;
        border-radius: 5px;
        width: 100%;

        pre {
            font-family: 'Fira Code', 'Ubuntu Mono', monospace;
        }

        &.err {
            color: #ff6a5e;
        }
    }
`;
